import { render, staticRenderFns } from "./HomeChild.vue?vue&type=template&id=aa7c9014&"
import script from "./HomeChild.vue?vue&type=script&lang=js&"
export * from "./HomeChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports